/** Navigation component for the header 
 * Part of Header.jsx, each link is wrapped in TapedPaper component for styling
 * Future links / pages ideas:
 * - Notes board - corkboard with sticky notes that can be added anywhere
 * - Pi Runner game
 * - QR Code minigame / sudoku
 * - ChatGPT hierarchical helper - ADHD wrapper for ChatGPT
 * - LoFi corner
*/

import { NavLink } from 'react-router-dom';
import TapedPaper from './TapedPaper';

function Navigation() {
    return (
        <nav className="navigation-component">
            <NavLink to="/" className="nav-link">
                <TapedPaper>Home</TapedPaper>
            </NavLink>
            <NavLink to="/pi-runner" className="nav-link">
                <TapedPaper>Pi Runner</TapedPaper>
            </NavLink>
            <NavLink to="/blog" className="nav-link">
                <TapedPaper>Blog</TapedPaper>
            </NavLink>
            <NavLink to="/goals-planner" className="nav-link">
                <TapedPaper>Goals Planner</TapedPaper>
            </NavLink>
        </nav>
    );
}

export default Navigation;